import React from "react";

const ContextMenu = ({ contextMenuPosition, selectedFiles, canPaste, onItemClicked, hasTarget, isSharedFolder }) => {
    
    const hasFolder = selectedFiles.some(file => file.isFolder);

    const handleContextMenuClick = (event, option) => {
        onItemClicked(event, option);
    };

    return (
        <div className="context-menu" style={contextMenuPosition}>
            {hp.store.prms.canRead && hasTarget ? (
                <div className="context-menu-option" onClick={(event) => handleContextMenuClick(event, "open")}>
                    <em className="la la-folder"></em>&nbsp; {__('buttons_open')}
                </div>
            ) : null}

            <div
                className="context-menu-option border-bottom"
                onClick={(event) => handleContextMenuClick(event, "refresh")}
            >
                <em className="la la-sync"></em>&nbsp; {__('buttons_update')}
            </div>

            {hp.store.prms.canEdit && hasTarget ? (
                <div className="context-menu-option" onClick={(event) => handleContextMenuClick(event, "copy")}>
                    <em className="la la-copy"></em>&nbsp; {__('buttons_copy')}
                </div>
            ) : null}

            {hp.store.prms.canEdit && hasTarget && !isSharedFolder ? (
                <div className="context-menu-option" onClick={(event) => handleContextMenuClick(event, "cut")}>
                    <em className="la la-cut"></em>&nbsp; {__('buttons_cut')}
                </div>
            ) : null}

            {hp.store.prms.canEdit && (canPaste || hasTarget) && !isSharedFolder ? (
                <div
                    className={`context-menu-option border-bottom ${!canPaste ? "disabled" : ""}`}
                    onClick={(event) => handleContextMenuClick(event, "paste")}
                >
                    <em className="la la-paste"></em>&nbsp;{__('buttons_paste')}
                </div>
            ) : null}

            {hp.store.prms.canEdit && !hasTarget && !isSharedFolder ? (
                <div className={`context-menu-option`} onClick={(event) => handleContextMenuClick(event, "newFolder")}>
                    <em className="la la-plus"></em>&nbsp; {__('buttons_new_folder')}
                </div>
            ) : null}

            {hp.store.prms.canEdit && hasTarget && !isSharedFolder ? (
                <div
                    className={`context-menu-option ${selectedFiles.length > 1 ? "disabled" : ""}`}
                    onClick={(event) => handleContextMenuClick(event, "rename")}
                >
                    <em className="la la-edit"></em>&nbsp; {__('buttons_rename')}
                </div>
            ) : null}

            {hp.store.prms.canDelete && hasTarget && !isSharedFolder ? (
                <div
                    className="context-menu-option border-bottom"
                    onClick={(event) => handleContextMenuClick(event, "delete")}
                >
                    <em className="la la-trash"></em>&nbsp; {__('buttons_delete')}
                </div>
            ) : null}

            {hp.store.prms.canEdit && hasTarget && !isSharedFolder ? (
                <div className="context-menu-option" onClick={(event) => handleContextMenuClick(event, "share")}>
                    <em className="la la-share-square"></em>&nbsp; {__('buttons_share')}
                </div>
            ) : null}

            {hp.store.prms.canRead && hasTarget ? (
                <div className={`context-menu-option ${hasFolder || selectedFiles.length > 1 ? "disabled" : ""}`}  onClick={(event) => handleContextMenuClick(event, "copyUrl")}>
                    <em className="la la-link"></em>&nbsp; {__('buttons_copy_link')}
                </div>
            ) : null}

            {hp.store.prms.canRead && hasTarget ? (
                <div className={`context-menu-option border-bottom ${hasFolder || selectedFiles.length > 1 ? "disabled" : ""}`}  onClick={(event) => handleContextMenuClick(event, "download")}>
                    <em className="la la-download"></em>&nbsp; {__('buttons_download')}
                </div>
            ) : null}

            {hasTarget ? (
                <div
                    className={`context-menu-option ${selectedFiles.length > 1 ? "disabled" : ""}`}
                    onClick={(event) => handleContextMenuClick(event, "info")}
                >
                    <em className="la la-info-circle"></em>&nbsp; {__('buttons_info')}
                </div>
            ) : null}
        </div>
    );
};

export default ContextMenu;
